import { useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Pagination, Mousewheel, A11y } from 'swiper'
import { ProjectTeaserWithTracking, ProjectPreview, Chevron } from 'shared'
import classNames from 'classnames'
import { PopoverIcon, JSONFetcher } from 'shared'
import { usePromise } from 'react-use'

SwiperCore.use([Navigation, Pagination, Mousewheel, A11y])

export const ProjectSwiper = props => {
  const mounted = usePromise()
  const [isLoading, setIsLoading] = useState(true)
  const [projects, setProjects] = useState([])
  const id = Math.random().toString(36).substr(2, 9)

  useEffect(() => {
    (async () => {
      const json = await mounted(JSONFetcher.call({ url: props.apiUrl }))
      setProjects(json.data)
      setIsLoading(false)
    })()
  }, [])

  const sortedProjects = () => {
    if (props.orderedIds) {
      const orderedIds = JSON.parse(props.orderedIds)

      return projects.sort((a, b) => {
        const indexA = orderedIds.indexOf(a.id)
        const indexB = orderedIds.indexOf(b.id)

        if (indexA == indexB) {     // both are -1
          return 0                  // keep order from API
        } else if (indexA == -1) {
          return 1                  // sort b before a
        } else if (indexB == -1) {
          return -1                 // sort a before b
        } else {
          return indexA - indexB    // sort based on their index in orderedIds
        }
      })
    } else {
      return projects
    }
  }

  const renderPreviews = () => {
    let numberOfPreviews = window.innerWidth > 450 ? 3 : 1
    return <div className='row'>
      {[...Array(numberOfPreviews).keys()].map(i => <div className='col-md-8' key={i}><ProjectPreview /></div>)}
    </div>
  }

  const slides = sortedProjects().map((project, index) => (
    <SwiperSlide key={project.id}>
      <ProjectTeaserWithTracking
        project={project}
        index={index}
        trackingPath='/home-page/featured-projects'
        swiper
        showDescription={!!props.showDescription}
        progressbarColor={props.progressbarColor}
        className='w-100'
      />
    </SwiperSlide>
  ))

  if (isLoading) return renderPreviews()

  const hasProjects = projects.length > 0

  return (
    <div className='relative'>
      {props.pagination === 'arrow-buttons' && <ArrowPagination id={id} projectsCount={projects.length} />}
      <div className={classNames('generic-teaser-swiper user-select-none', hasProjects && props.pagination === 'chevron' && 'px-12')}>
        {props.pagination === 'chevron' && projects.length > 3 && <Chevron id={`featured-list-${id}-prev`} direction='left' />}
        <Swiper
          className='pb-0'
          spaceBetween={30}
          slidesPerView={1}
          pagination={projects.length > 1 ? { clickable: true } : false}
          navigation={{
            nextEl: `#featured-list-${id}-next`,
            prevEl: `#featured-list-${id}-prev`,
            disabledClass: 'is-disabled',
          }}
          roundLengths
          mousewheel={{ forceToAxis: true }}
          breakpoints={{
            450: {
              slidesPerView: 3
            }
          }}
        >
          {hasProjects ? slides : <NoProjectsHint noProjectsMessage={props.noProjectsMessage} noProjectsPopover={props.noProjectsPopover} />}
        </Swiper>
        {props.pagination === 'chevron' && projects.length > 3 && <Chevron id={`featured-list-${id}-next`} direction='right' />}
      </div>
    </div>
  )
}

const NoProjectsHint = (props) => {
  if (!props.noProjectsMessage) return null

  return <>
    <span className='text-grey-dark italic pr-1'>{props.noProjectsMessage}</span>
    <PopoverIcon popover={props.noProjectsPopover} />
  </>
}

const ArrowPagination = (props) => {
  if (props.projectsCount < 4) return null
  return <div className={'btn-group btn-group-with-small-arrows'} style={{ position: 'absolute', top: '-3.4rem', right: 0 }}>
    <a id={`featured-list-${props.id}-prev`} className='btn btn-secondary'>
      <i className='fa fa-caret-left'></i>
    </a>
    <a id={`featured-list-${props.id}-next`} className='btn btn-secondary'>
      <i className='fa fa-caret-right'></i>
    </a>
  </div>
}
